import app from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

import * as ROUTES from "../../constants/routes";


var config = {
    apiKey: "AIzaSyCXvzekggRYc302_cwQX_G8cSRaNZkIoz4",
    authDomain: "thakaa-e6e86.firebaseapp.com",
    databaseURL: "https://thakaa-e6e86.firebaseio.com",
    projectId: "thakaa-e6e86",
    storageBucket: "thakaa-e6e86.appspot.com",
    messagingSenderId: "551191794543",
    appId: "1:551191794543:web:03410f6e11dc5a64"
};

/*{
    apiKey: "AIzaSyCoHUWp7AAlhwOUno067Uocd_UoYC6rCvQ",
    authDomain: "playground-a137e.firebaseapp.com",
    databaseURL: "https://playground-a137e.firebaseio.com",
    projectId: "playground-a137e",
    storageBucket: "playground-a137e.appspot.com",
    messagingSenderId: "927729195726",
    appId: "1:927729195726:web:a62f105fa827ec75d28e9f",
};*/


class Firebase {
    constructor() {
        app.initializeApp(config);

        this.auth = app.auth();
        this.db = app.firestore();
        this.storage = app.storage();
        this.FieldValue = app.firestore.FieldValue;

    }

    doCreateUserWithEmailandPassword = (email, password) =>
        this.auth.createUserWithEmailAndPassword(email, password);

    doSignInWithEmailandPassword = (email, password) =>
        this.auth.signInWithEmailAndPassword(email, password);

    doSignOut = () => {
        this.auth.signOut();
        console.log("User logged out");
        window.location.replace(ROUTES.HOME);
    };

    doPasswordReset = (email) => this.auth.sendPasswordResetEmail(email);

    doPasswordUpdate = (password) =>
        this.auth.currentUser.updatePassword(password);

    /// ** User API ***

    FieldValue = () => this.db.FieldValue;

    arrayUnion = (args) => this.FieldValue.arrayUnion.apply(this, args);

    arrayRemove = (args) => this.FieldValue.arrayRemove.apply(this, args);

    user = (uid) => this.db.doc(`users_dev/${uid}`);

    users = () => this.db.collection("users_dev");

    realUsers = () => this.db.collection("users");
    realUser = (uid) => this.db.doc(`users/${uid}`);

    events = () => this.db.collection("events");

    event = (uid) => this.db.doc(`events/${uid}`);

    registrations = (eid) => this.db.collection(`events/${eid}/registrations`);
    registration = (eid, uid) =>
        this.db.doc(`events/${eid}/registrations/${uid}`);

    ref = (uid) => this.db.doc("users/" + uid);

    teamMembers = () => this.db.collection("team_members");

    collaborators = () => this.db.collection("collaborators");

    ref = (uid, collection) => this.db.doc(collection + "/" + uid);

    calendarevents = () => this.db.collection("calendar_events");

    calendarevent = (eid) => this.db.doc(`calendar_events/${eid}`);

    teamMembers = () => this.db.collection("team_members");

    collaborators = () => this.db.collection("collaborators");

    challenges = () => this.db.collection("challenges");

    challenge = (cid) => this.db.collection("challenges").doc(cid);

    teams = () => this.db.collection("teams");

    team = (tid) => this.db.collection("teams").doc(tid);

    ref = (uid, collection) => this.db.doc(collection + "/" + uid);

    getRef = (ref) => ref.get();

    query = (dbRef, property, value) =>
        dbRef.where("" + property + "", "==", "" + value + "");

    venues = () => this.db.collection("venues");

    programs = () => this.db.collection("programs");

    storage = () => this.storage;

    storageRef = () => this.storage.ref();
}

export default Firebase;